'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import CCPALink from './CCPALink';

export default function Footer() {
  return (
    <footer className="footer-minimal py-10 px-6 pb-24 md:pb-10" role="contentinfo">
      <div className="max-w-7xl mx-auto">
        {/* Pattern 7 — Arc Browser Split */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          {/* Left: Logo + tagline */}
          <div className="flex items-center gap-3">
            <Image
              src="/assets/images/ChatGPT_Image_Mar_12_2026_02_29_00_PM-1774386710460.png"
              alt="PDA Letting Agents logo"
              width={40}
              height={40}
              className="rounded-full flex-shrink-0"
            />
            <div>
              <span className="text-[#1C1C1A] font-display font-medium text-sm block leading-none">
                PDA Estates
              </span>
              <span className="text-[#6B7280] text-[11px] block mt-0.5">
                Chester&apos;s trusted letting agents — lettings &amp; property management
              </span>
            </div>
          </div>

          {/* Right: Links */}
          <nav className="flex flex-wrap gap-x-6 gap-y-2" aria-label="Footer navigation">
            {[
              { label: 'Landlords', href: '/landlord-services' },
              { label: 'Tenants', href: '/tenant-services' },
              { label: 'Properties to Rent', href: '/properties' },
              { label: 'About', href: '/about' },
              { label: 'Contact', href: '/contact' },
            ]?.map((link) => (
              link?.href?.startsWith('#') ? (
                <a
                  key={link?.label}
                  href={link?.href}
                  className="text-[14px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors focus:outline-none focus:ring-2 focus:ring-teal-DEFAULT rounded"
                >
                  {link?.label}
                </a>
              ) : (
                <Link
                  key={link?.label}
                  href={link?.href}
                  className="text-[14px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors focus:outline-none focus:ring-2 focus:ring-teal-DEFAULT rounded"
                >
                  {link?.label}
                </Link>
              )
            ))}
          </nav>
        </div>

        {/* Legal pages row */}
        <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2">
          <span className="text-[12px] text-[#8A9BB0] font-semibold tracking-wide uppercase">Legal &amp; Landlord:</span>
          <Link href="/landlord-services" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord Services Chester
          </Link>
          <Link href="/property-management-services" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Property Management Services
          </Link>
          <Link href="/case-studies" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Case Studies
          </Link>
          <Link href="/switch-to-pda" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Switch to PDA
          </Link>
          <Link href="/property-valuation" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Property Valuation Tool
          </Link>
          <Link href="/renters-rights-act" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Renters Rights Act
          </Link>
          <Link href="/landlord-faq" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord FAQ
          </Link>
          <Link href="/fixed-fees-landlords" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Fixed Fees
          </Link>
          <Link href="/hmo-licensing" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            HMO Licensing
          </Link>
          <Link href="/landlord-compliance" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord Compliance
          </Link>
          <Link href="/regulatory" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Regulatory Information
          </Link>
          <Link href="/zero-deposit" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Zero Deposit
          </Link>
          <Link href="/properties?department=residential-sales" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Properties for Sale
          </Link>
          <Link href="/portfolio-landlord" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Portfolio Landlord
          </Link>
          <Link href="/rental-yield-calculator" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Rental Yield Calculator
          </Link>
          <Link href="/portfolio-landlord#yield-calculator" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord Newsletter
          </Link>
          <Link href="/accidental-landlord" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Accidental Landlord Guide
          </Link>
          <Link href="/landlord-portal" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord Portal
          </Link>
          <Link href="/first-time-landlord" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            First-Time Landlord Guide
          </Link>
          <Link href="/why-pda" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Why Choose PDA
          </Link>
          <Link href="/resources" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord Resources
          </Link>
          <Link href="/testimonials" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord Testimonials
          </Link>
        </div>

        {/* Landlord Guides row */}
        <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2">
          <span className="text-[12px] text-[#8A9BB0] font-semibold tracking-wide uppercase">Landlord Guides:</span>
          <Link href="/guides" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            All Guides
          </Link>
          <Link href="/guides/letting-agents-chester" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Best Letting Agents Chester
          </Link>
          <Link href="/guides/average-rent-chester" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Average Rent Chester
          </Link>
          <Link href="/guides/property-management-cost-chester" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Property Management Cost Chester
          </Link>
          <Link href="/guides/landlord-legal-requirements-chester" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Landlord Legal Requirements Chester
          </Link>
          <Link href="/guides/how-long-to-find-tenant-chester" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            How Long to Find a Tenant Chester
          </Link>
        </div>

        {/* Area Guides row */}
        <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2">
          <span className="text-[12px] text-[#8A9BB0] font-semibold tracking-wide uppercase">Area Guides:</span>
          <Link href="/area-guides/chester" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Letting Agent Chester
          </Link>
          <Link href="/area-guides/hoole" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Letting Agent Hoole
          </Link>
          <Link href="/area-guides/wirral" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Letting Agent Wirral
          </Link>
          <Link href="/area-guides/north-wales" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Letting Agent North Wales
          </Link>
          <Link href="/area-guides/north-wales" className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors">
            Property Management Wrexham
          </Link>
        </div>

        {/* SRA Compliance row */}
        <div className="mt-3 flex flex-wrap gap-x-5 gap-y-2">
          <span className="text-[12px] text-[#8A9BB0] font-semibold tracking-wide uppercase">SRA Compliance:</span>
          <Link href="/our-firm-values" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
            Our Firm Values
          </Link>
          <Link href="/our-firm-values/diversity-and-inclusion" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
            Diversity &amp; Inclusion
          </Link>
          <Link href="/our-firm-values/modern-slavery-act" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
            Modern Slavery Act
          </Link>
          <Link href="/our-firm-values/anti-bribery-and-corruption" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
            Anti-Bribery &amp; Corruption
          </Link>
          <Link href="/terms-of-business" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
            Terms of Business
          </Link>
          <Link href="/complaints-policy" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
            Complaints Policy
          </Link>
        </div>

        {/* Second row */}
        <div className="mt-6 pt-6 border-t border-[#E0DDD4] flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex flex-col gap-2">
            {/* NAP block — consistent across all directories */}
            <address className="not-italic">
              <p className="text-[13px] font-semibold text-[#1C1C1A]">PDA Estates</p>
              <p className="text-[12px] text-[#6B7280]">Crown Buildings, 121A Saughall Road, Blacon, Chester, CH1 5ET</p>
              <a href="tel:+441244380380" className="text-[12px] text-[#1B6B5A] hover:text-[#228870] transition-colors">
                01244 380380
              </a>
            </address>
            <p className="text-[12px] text-[#6B7280] leading-relaxed max-w-xl">
              PDA Estates is a trading name of PDA Law Solicitors Limited, authorised and regulated by the{' '}
              <a
                href="https://www.sra.org.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-[#1C1C1A] transition-colors"
              >
                Solicitors Regulation Authority
              </a>{' '}
              (No. 622755). Registered in England and Wales, Company No. 08133025. Registered office: Crown Buildings, 121A Saughall Road, Blacon, Chester CH1 5ET.{' '}
              <a
                href="https://www.sra.org.uk/consumers/register/organisation/?sraNumber=622755"
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-[#1C1C1A] transition-colors"
              >
                View our SRA record
              </a>
              .
            </p>
            <p className="text-[12px] text-[#8A9BB0]">
              © 2026 PDA Estates. All rights reserved.
            </p>
          </div>
          <div className="flex flex-col gap-4 items-start md:items-end">
            {/* TPO + CMP accreditation badges */}
            <div className="flex items-center gap-4 flex-wrap">
              <a
                href="https://www.tpos.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 border border-[#E0DDD4] rounded-lg px-3 py-2 bg-white hover:border-[#1B6B5A] transition-colors"
                aria-label="The Property Ombudsman — member"
              >
                <svg className="w-5 h-5 text-[#1B6B5A]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <div>
                  <p className="text-[10px] font-semibold text-[#1C1C1A] leading-none">The Property</p>
                  <p className="text-[10px] font-semibold text-[#1C1C1A] leading-none">Ombudsman</p>
                  <p className="text-[9px] text-[#6B7280] leading-none mt-0.5">TPO Member</p>
                </div>
              </a>
              <a
                href="https://www.clientmoneyprotect.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 border border-[#E0DDD4] rounded-lg px-3 py-2 bg-white hover:border-[#1B6B5A] transition-colors"
                aria-label="Client Money Protection scheme member"
              >
                <svg className="w-5 h-5 text-[#1B6B5A]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <div>
                  <p className="text-[10px] font-semibold text-[#1C1C1A] leading-none">Client Money</p>
                  <p className="text-[10px] font-semibold text-[#1C1C1A] leading-none">Protection</p>
                  <p className="text-[9px] text-[#6B7280] leading-none mt-0.5">CMP Member</p>
                </div>
              </a>
            </div>
            <div className="flex items-center gap-5 flex-wrap">
              {/* Socials */}
              <a
                href="https://www.facebook.com/PdaEstateAgents"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="PDA Estates on Facebook"
                className="text-[#8A9BB0] hover:text-[#1B6B5A] transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a
                href="https://twitter.com/pdaestates"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="PDA Estates on X"
                className="text-[#8A9BB0] hover:text-[#1B6B5A] transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <span className="w-px h-4 bg-[#E0DDD4]" aria-hidden="true" />
              <Link href="/privacy" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
                Privacy Policy
              </Link>
              <Link href="/cookies" className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors">
                Cookie Policy
              </Link>
              <CCPALink />
              <button
                onClick={() => {
                  const event = new CustomEvent('openCookiePreferences');
                  window.dispatchEvent(event);
                }}
                className="text-[13px] font-medium text-[#6B7280] hover:text-[#1C1C1A] transition-colors"
                aria-label="Open cookie preferences"
              >
                Cookie Preferences
              </button>
              <a
                href="https://www.pdalaw.co.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[13px] font-medium text-[#1B6B5A] hover:text-[#228870] transition-colors"
              >
                PDA Law ↗
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}